const menuCz = {
    "add_to_cart": "Přidat do košíku",
    "add_to_order": "Přidat k objednávce",
    "already_in_cart": "Už ve vašem košíku",
    "update_order_item": "Aktualizovat objednávku",
    "delete_order_item": "Odebrat položku",
    "available_categories": "Kategorie nabídky",
    "search_menu_placeholder": "Hledat v nabídce",
    "guides": {
        "scan_qr": "Naskenujte QR kód na stole telefonem",
        "order": "Objednejte si vybrané položky z telefonu",
        "pay": "Plaťte samostatně nebo najednou z telefonu",
        "accept": "Pokračovat"
    },
    "index_image": "Indexový obrázek",
    "menu_saved": "Nabídka uložena",
    "new_category": "Nová kategorie",
    "menu_editor": "Nabídka editoru",
    "new_item": "Nová položka",
    "menu": "Menu",
    "allergens": "Alergeny",
    "generate_qr": "Generovat QR kód",
    "allergen_list": {
        "gluten": "Lepek",
        "crustaceans": "Korýši",
        "eggs": "Vejce",
        "fish": "Ryba",
        "peanuts": "Arašídy",
        "soybeans": "Sójové boby",
        "milk": "Mléko",
        "nuts": "Ořechy",
        "celery": "Celer",
        "mustard": "Hořčice",
        "sesame": "Sezam",
        "sulphur_dioxide": "Oxid siřičitý",
        "lupin": "Lupina",
        "molluscs": "Měkkýši",
        "vegan": "Veganské"
    },
    "add_allergen": "Přidat alergen",
    "auto_translate": "Překlad menu",
    "no_category_name": "V aktuálním jazyce není zadán žádný název kategorie.",
    "no_item_name": "V aktuálním jazyce není zadán žádný název položky.",
    "category_and_items_language": "Jazyk kategorií a položek",
    "auto_translate_title": "Automatický překlad menu lze použít pouze pro kategorie a položky, které již byly uloženy. Doporučuje se vyplnit původní jazyk.",
    "auto_translate_description": "Tato funkce využívá Překladač Google. Překlady nejsou vždy přesné, proto se vyplatí si je ověřit.",
    "translate_from": "Přeložit z",
    "translate_to": "K těmto jazykům",
    "auto_translate_error_invalid_languages": "Pro překlad byly vybrány neplatné jazyky",
    "auto_translate_success": "Menu úspěšně přeloženo",
    "auto_translate_error_permission": "Nemáte oprávnění k překladu menu.",
    "auto_translate_error_generic": "Během překladu došlo k neznámé chybě",
    "auto_translate_feature_not_available": "Automatický překlad menu je k dispozici pouze s předplatným PRO.",
    "change_subscription_plan": "Změnit předplatné",
    "menu_headers": "Záhlaví a zápatí menu",
    "menu_header_editor_title": "Záhlaví a zápatí nabídky jsou texty, které se zobrazují v horní a dolní části vaší online nabídky a které si můžete libovolně specifikovat.",
    "menu_header_feature_not_available": "Úprava záhlaví a zápatí nabídky je k dispozici pouze s předplatným PRO.",
    "menu_header": "Záhlaví nabídky",
    "menu_header_placeholder": "Napište krátkou uvítací zprávu nebo zvýrazněte aktuální nabídku",
    "menu_footer": "Zápatí nabídky",
    "menu_footer_placeholder": "Můžete zadat informace o servisních poplatcích, alergenech nebo další důležité informace",
    "menu_header_save_success": "Záhlaví a zápatí nabídky byly úspěšně uloženy",
    "menu_header_save_error": "Při ukládání záhlaví a zápatí nabídky došlo k chybě.",
    "menu_header_permission_error": "Nemáte oprávnění k úpravě záhlaví a zápatí nabídky.",
    "menu_header_generic_error": "Při načítání záhlaví a zápatí nabídky došlo k neznámé chybě.",
    "menu_import": "Import nabídky",
    "import_success": "Poslední import byl úspěšně dokončen",
    "import_failed": "Poslední import se nezdařil kvůli exportu na straně serveru.",
    "attached_document": "Přiložený dokument",
    "allowed_file_types": "Povolené typy souborů: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Jazyk dokumentu",
    "import_options_pro_helpertext": "Možnosti „Deaktivovat“ a „Přidat“ jsou k dispozici pouze s předplatným PRO.",
    "import_option_helpertexts": {
        "replace": "Aktuální kategorie a položky nabídky budou smazány a nahrazeny nově vygenerovanou nabídkou.",
        "deactivate": "Aktuální kategorie a položky nabídky budou deaktivovány a bude přidána nově vygenerovaná nabídka.",
        "add": "Aktuální nabídka zůstane zachována a nové položky nabídky budou přidány za aktuální nabídku."
    },
    "import_type": "Typ importu",
    "import_options": {
        "replace": "Nahradit",
        "deactivate": "Deaktivovat",
        "add": "Přidat"
    },
    "menu_import_tooltip": "Nahrajte soubor s jídelním lístkem vaší restaurace nebo poskytněte odkaz na webové stránky, které jej obsahují. V obou případech se ujistěte, že je jídelní lístek v dokumentu k dispozici v textové podobě, protože obrázky zpracovávat nemůžeme. Po zahájení importu naše umělá inteligence soubor automaticky zpracuje a vytvoří nový jídelní lístek ve vybraném jazyce. Pokud chcete položky později přeložit do více jazyků, použijte funkci „Překlad jídelního lístku“! Proces importu trvá 5–10 minut.",
    "menu_import_replace_warning": "Aktuálně vybraná metoda importu smaže aktuální menu a nahradí ho novým. Ujistěte se prosím, že nahraný soubor má správný formát a obsah, protože operace je nevratná! Pokud nechcete aktuální menu smazat, zvolte prosím jinou metodu importu.",
    "start_import": "Importovat",
    "file_or_url_required": "Vyberte soubor nebo zadejte URL adresu webu.",
    "file_and_url_error": "Můžete poskytnout pouze soubor nebo URL, nikoli obojí.",
    "import_site_url": "URL adresa webových stránek",
    "import_in_progress": "Probíhá import",
    "import_duration": "Může to trvat několik minut",
    "listing_manager_info": {
        "summary": "S Mozrestem můžete snadno spravovat své nabídky a recenze z jediné platformy. Ušetřete čas, vylepšete si online reputaci a zvyšte provozní efektivitu.",
        "bullet_1": "Okamžitě aktualizujte své záznamy na Tripadvisoru, Apple Maps, Googlu, Facebooku, Quandoo a Bingu jediným kliknutím.",
        "bullet_2": "Získejte upozornění v reálném čase, když se vaše otevírací doba a dostupnost neshodují, čímž předejdete zklamání hostů a negativním recenzím.",
        "bullet_3": "Rychle zkontrolujte úplnost svého inzerátu a ujistěte se, že všechny důležité údaje – jako jsou fotografie, jídelní lístky a otevírací doba – jsou přesné a aktuální.",
        "setup_button": "Nastavení Mozrestu",
        "pro_warning": "Tato funkce vyžaduje předplatné PRO."
    },
    "listing_manager_tabs": {
        "Listing": "Výpis",
        "ListingAnalytics": "Analýza nabídek",
        "ReviewsPage": "Recenze",
        "ReviewAnalytics": "Analýza recenzí",
        "ReplyTemplates": "Šablony odpovědí",
        "Notifications": "Oznámení"
    },
    "review_manager_set_title": "Nastavení správce recenzí",
    "review_manager_set_description": "Prosím, uveďte nějaké informace o vaší firmě, abychom mohli vytvořit základní nastavení.",
    "confirm_settings": "Potvrdit nastavení"
};

export default menuCz;
